<template>
    <transition>
        <div class="forget-container-inner">
            <h4 class="forget-title">{{$t('forget_passwd')}}</h4>
            <p class="forget-subtitle">{{$t('input_send_phone')}}</p>
            <el-form :model="formData" :rules="formRules" ref="formRef" @submit.native.prevent>
                <el-form-item prop="account">
                    <el-input v-model="formData.account" :placeholder="$t('mobile')" type="number">
                        <el-select
                            v-model="formData.code"
                            placeholder="code"
                            slot="prepend"
                            class="input-with-select"
                            filterable
                        >
                            <el-option
                                v-for="item in $store.getters.countryList"
                                :key="item.country_id"
                                :label="'+' + item.code"
                                :value="'+' + item.code"
                            >
                                <span style="float: left;color: #484848;">{{item.name}}</span>
                                <span style="float: right;color: #767676;">{{`+${item.code}`}}</span>
                            </el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item prop="vCode">
                    <el-input v-model="formData.vCode" :placeholder="$t('captcha')">
                        <button
                            slot="append"
                            class="send-btn"
                            :class="{'send-btn-active': !sending}"
                            @click.stop="send"
                        >{{this.sending ? `${$t('resend')}(${timer/1000}s)` : $t('send_code')}}</button>
                    </el-input>
                </el-form-item>
                <button class="form-btn" @click="confirm">{{$t('confirm')}}</button>
            </el-form>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                account: "",
                code: `+${this.$store.getters.country.code || 86}`,
                vCode: ""
            },
            formRules: {
                account: [
                    {
                        required: true,
                        message: this.$t("mobile_error"),
                        trigger: "none"
                    }
                ],
                vCode: [
                    {
                        required: true,
                        message: this.$t("vcode_error"),
                        trigger: "none"
                    }
                ]
            },
            sending: false,
            clockId: null,
            timer: 45000
        };
    },
    methods: {
        send() {
            const delay = 1000;
            if (!this.formData.account) {
                // this.$message('手机号不能为空', 'error');
                return;
            }
            if (!this.clockId) {
                this.sending = true;
                this.sendCode();
                this.clockId = setInterval(() => {
                    if (this.timer === 0) {
                        this.sending = false;
                        this.timer = 45000;
                        clearInterval(this.clockId);
                    } else {
                        this.timer = this.timer - 1000;
                    }
                }, delay);
            }
        },
        sendCode() {
            this.$req
                .post("retsendmobcode", {
                    area_code: this.formData.code,
                    account: this.formData.account
                })
                .then(({ data }) => {
                    if (data.code === "2000") {
                        this.$msg.success(this.$t("msg_send"));
                    } else {
                        this.$msg.error(data.msg);
                        this.sending = false;
                        this.timer = 45000;
                    }
                });
        },
        confirm() {
            this.$refs["formRef"].validate(valid => {
                if (!valid) {
                    // this.$message('请检查您的表单', 'error')
                    return;
                }
                this.$req
                    .post("checkretphonecode", {
                        area_code: this.formData.code,
                        account: this.formData.account,
                        code: this.formData.vCode
                    })
                    .then(({ data }) => {
                        if (data.code === "2000") {
                            //跳转至重置密码
                            this.$emit(
                                "updateInfo",
                                this.formData.code,
                                this.formData.account,
                                data.data.encryption_code,
                                data.data.token
                            );
                            this.$store.dispatch("updateForgetFlow", {
                                show: true,
                                type: "password"
                            });
                            this.resetFields();
                        } else {
                            this.$msg.error(data.msg);
                        }
                    });
            });
        },
        resetFields() {
            this.$refs["formRef"].resetFields();
        }
    }
};
</script>

<style lang="scss">
.forget-container-inner .el-select .el-input {
    width: 100px;
}
.forget-container-inner .el-input-group__prepend {
    background-color: #fff;
}
.forget-container-inner .el-input-group__append {
    padding: 0;
    width: auto;
}
</style>

<style scoped>
.send-btn {
    height: 39px;
    width: 100%;
    appearance: none;
    background-color: transparent;
    color: #c5c5c5;
    cursor: not-allowed;
}
.send-btn-active {
    background-color: #00a9ba;
    color: #fff;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Forget/Mobile.vue